import React, { useState } from "react";
import { ScrollView, View } from "react-native";
import Icon from "../components/Icon";
import ListItem from "../components/lists/ListItem";
import Screen from "../components/Screen";
import config from "../config/config";
import useUser from "../hooks/useUser";

function ToolsScreen({ navigation }) {
    const { user } = useUser();
    const [message, setMessage] = useState();

    return (
        <Screen title={"Tools"} navigation={navigation} message={message} setMessage={setMessage}>
            <ScrollView>
                <ListItem
                    title="New Product"
                    subTitle="Add a new product"
                    IconComponent={<Icon name="plus-circle" backgroundColor={config.colors.tertiary} />}
                    onPress={() => {
                        navigation.navigate("NewProduct");
                    }}
                    utilityComponent={<Icon name="arrow-right" backgroundColor={config.colors.white} iconColor={config.colors.tertiary} />}
                />
                <ListItem
                    title="Profile"
                    IconComponent={<Icon name="account" backgroundColor={config.colors.tertiary} />}
                    onPress={() => {
                        navigation.navigate("Account");
                    }}
                    utilityComponent={<Icon name="arrow-right" backgroundColor={config.colors.white} iconColor={config.colors.tertiary} />}
                />
                {user.type == "admin" && (
                    <View>
                        <ListItem
                            title="Users"
                            subTitle="Manage User Accounts"
                            IconComponent={<Icon name="account-group" backgroundColor={config.colors.red} />}
                            onPress={() => navigation.navigate("Users")}
                            utilityComponent={<Icon name="arrow-right" backgroundColor={config.colors.white} iconColor={config.colors.tertiary} />}
                        />
                    </View>
                )}
            </ScrollView>
        </Screen>
    );
}

export default ToolsScreen;
